import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from "@angular/core";
import { IInvoice } from "@rfm/shared-interfaces";

@Component({
  selector: "app-invoice-history",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./invoice-history.component.html",
  styleUrls: ["./invoice-history.component.scss"],
})
export class InvoiceHistoryComponent implements OnInit, OnChanges {
  @Input()
  invoices = signal<IInvoice[] | undefined>(undefined);

  hasInvoices: boolean = false;

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.invoices() && this.invoices()!.length > 0) {
      this.hasInvoices = true;
    } else {
      this.hasInvoices = false;
    }
  }

  ngOnInit() {}
}
